import {
  CustomButton,
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomInput,
  successDialog,
  warningDialog,
  Text,
  useText,
} from '@src/components';
import { Alert, Form } from 'antd';
import LoginLayout from '@src/layout/LoginLayout';
import React, { useCallback, useEffect, useState } from 'react';
import warning from '@src/assets/icons/icon-profil-warning.svg';
import { useDispatch } from 'react-redux';
import { forgotPassword } from '@src/store/slice/authSlice';
import '@src/styles/login/forgotPassword.scss';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const ForgotPassword = ({ history }) => {
  const dispatch = useDispatch();
  const [isVisible, setVisible] = useState(false);
  const [isError, setIsError] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const loginUsernameSelectInputForgotPassword = useText('loginUsernameSelectInputForgotPassword');
  const yourTransactionHasBeenSuccessfullyCompleted = useText('yourTransactionHasBeenSuccessfullyCompleted');

  const [form] = Form.useForm();



  useEffect(() => {
    const params = new URLSearchParams(window?.location?.search);
    const paramError = params?.get('error');
    if (paramError === 'true') {
      setIsError(true);
    } else {
      setIsError(false);
    }
  }, []);

  const onFinish = useCallback(
    async (values) => {
      setButtonDisabled(true);
      try {

        const token = await executeRecaptcha('login');
        const body = {
          captchaKey: token,
          ...values,
        };

        const action = await dispatch(forgotPassword(body));
        if (action.payload.data === 'warning') {
          warningDialog({
            title: <Text t="information" />,
            message: action?.payload?.message || 'Hata ile karşılaşıldı',
            onOk: () => {
              setVisible(false);
            },
          })
        }
        else if (forgotPassword.fulfilled.match(action)) {
          successDialog({
            title: <Text t="successfullySent" />,
            message: action?.payload?.message || yourTransactionHasBeenSuccessfullyCompleted,
            onOk: () => {
              history.push('/login');
            },
          });
        } else if (action?.payload?.error?.message === '1') {
          setVisible(true);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setButtonDisabled(false);
      }
    },
    [dispatch, history, executeRecaptcha, form],
  );

  useEffect(() => {
    const captchaRenderDom = document.querySelector('#captcha-render-dom');
    if (captchaRenderDom) {
      captchaRenderDom.style.display = 'block';
      window.grecaptcha?.reset();
    }
    return () => {
      if (captchaRenderDom) {
        captchaRenderDom.style.display = 'none';
      }
    };
  }, []);

  return (
    <LoginLayout isBackButton={true} className={'forgotPassword'}>
      <div className="rightSideLoginFormTitle">
        {isError ? <Text t="renewPassword" /> : <Text t="forgotPassword" />}
      </div>

      {isError && (
        <>
          <p className="info-reset-pasword-text">
            <Text t="forgotPasswordErrorMessage" />
          </p>

          <Alert
            message={
              <div className="alert-message-contain">
                <CustomImage src={warning} />
                <span>
                  <Text t="badPasswordResetLinkMessage" />
                </span>
              </div>
            }
            banner
            showIcon={false}
            className="custom-alert-error"
          />
        </>
      )}

      <CustomForm
        name="setPassword"
        form={form}
        initialValues={{}}
        onFinish={onFinish}
        autoComplete="off"
        layout={'vertical'}
      >
        <CustomFormItem
          label={<Text t="emailAdress" />}
          name="email"
          rules={[{ required: true, message: <Text t="checkEposta" /> }]}
        >
          <CustomInput id="forgotPassword-main-email-input" placeholder={useText('enterEposta')} />
        </CustomFormItem>

        {isVisible && (
          <CustomFormItem
            label={<Text t="loginUsernameInputForgotPassword" />}
            name="userName"
            rules={[{ required: true, message: <Text t="loginUsernameInputRequired" /> }]}
          >
            <CustomInput id="forgotPassword-main-userName-input" placeholder={loginUsernameSelectInputForgotPassword} />
          </CustomFormItem>
        )}

        <CustomFormItem>
          <CustomButton id="forgotPassword-main-primary-btn" type="primary" htmlType="submit" disabled={buttonDisabled} style={{ width: '100%' }}>
            <span className="submit">
              <Text t="sendMyPassBtn" />
            </span>
          </CustomButton>
        </CustomFormItem>
      </CustomForm>
    </LoginLayout>
  );
};

export default ForgotPassword;
